import { createDraftSafeSelector } from '@reduxjs/toolkit';

import { AppState } from '../types';

const selectSelf = (state: AppState) => state.user;

export const getActualUser = createDraftSafeSelector(selectSelf, (store) => {
  return store.currentUser?.user;
});
